import * as Icons from '@mui/icons-material'

export const socials: any[] = [
  {
    link: 'https://www.facebook.com/vuducdantn',
    icon: Icons.Facebook,
  },
  {
    link: 'https://www.linkedin.com/in/danducvu/',
    icon: Icons.LinkedIn,
  },
  {
    link: 'https://github.com/danvufs',
    icon: Icons.GitHub,
  },
]
